import * as React from 'react';
import { tableName, columnName } from 'app/area/case/case-data-model';
import { Entity } from 'app/types-shared';
import { getPrimaryEntityId, getEntityTypeFromStorePath } from 'app/infrastructure/store/entity';
import { getValue } from 'app/infrastructure/ui/form/selectors';
import { TileViewProps } from 'ui/tile-view';
import { TileView } from 'ui';
import { AddDocumentItemOptions } from 'app/infrastructure/ui/form/types';
import { ComponentDescriptor } from 'app/infrastructure/ui/types-uischema';
import styles from './loss-potential-evaluation-tile-view.scss';

export interface LossPotentialEvaluationTileViewProps extends TileViewProps {
  componentDescriptor: ComponentDescriptor;
  onSelectDocumentItem?: (path?: any) => void;
  onAddDocumentItem: (selectAddedItem?: boolean, options?: AddDocumentItemOptions) => void;
  childEntities: Entity[];
  textValidFrom: string;
  expandAll?: boolean;
}

export class LossPotentialEvaluationTileView extends React.PureComponent<LossPotentialEvaluationTileViewProps, any> {
  private dateIntlOption: any = { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' };

  private handleChange = (e: any) => {
    const { onSelectDocumentItem, childEntities } = this.props;
    onSelectDocumentItem && childEntities &&
      onSelectDocumentItem(childEntities.find(c => JSON.stringify(c.id) === e.target.value).id);
  };

  private onAddDocumentItem = () => {
    const { createDate, componentDescriptor } = this.props;
    const { entityTypePath } = componentDescriptor;

    let initialValues = undefined;

    if (entityTypePath[entityTypePath.length - 1] === tableName.lossPotentialEvaluation) {
      initialValues = {
        PotRiskEvValidFrom: [{ value: createDate() }]
      };
    } else {
      initialValues = {
        ResPotRiskEvValidFrom: [{ value: createDate() }]
      };
    }

    this.props.onAddDocumentItem(true, {
        initialValues
    });
  };

  private getMatchingId() {
    const { childEntities } = this.props;
    const { activeChildItem } = (this.props as any).hostProps();

    if (!childEntities || childEntities.length === 0) {
      return '';
    }

    // By default we select the last item if a descendant is not active.
    const defaultMatchingId = childEntities.reverse()[childEntities.length - 1].id;

    // 1. There is no active child item or it is the top level item.
    if (!activeChildItem || activeChildItem.length === 1) {
      return defaultMatchingId;
    }

    // Select those path elements that might be shared for later comparison.
    const partialPath = activeChildItem.slice(0, defaultMatchingId.length);

    const activeType = getEntityTypeFromStorePath(partialPath);
    const thisType = getEntityTypeFromStorePath(defaultMatchingId);

    // 2. The active child item might be a descendant.
    if (activeType === thisType) {
      return partialPath;
    }

    return defaultMatchingId;
  }

  public render() {
    const { childEntities, textValidFrom, formatDate, componentDescriptor } = this.props;
    const { selectEvaluation, printingColumnFix } = styles;
    const { entityTypePath } = componentDescriptor;

    let selectElement = undefined;

    if (childEntities && childEntities.length > 0) {
      const validFromFieldName = (columnName[entityTypePath[entityTypePath.length - 1]] as { validFrom: string }).validFrom;

      const values = childEntities.reverse().map(child => {
        const pk = getPrimaryEntityId(child);
        const validFrom = getValue(child, validFromFieldName).value;

        return <option key={`option-${pk}`} value={JSON.stringify(child.id)}>
          #{pk} - {textValidFrom} {formatDate(validFrom as Date, this.dateIntlOption)}
        </option>;
      });

      selectElement = values.length > 1 && (
        <div className={`d-flex justify-content-end ${selectEvaluation} ${printingColumnFix}`}>
          <div className="select-wrapper">
            <select className="form-control" id="select-evaluation"
              value={JSON.stringify(this.getMatchingId())}
              onChange={this.handleChange}>
              <option disabled hidden value="" />
              {values}
            </select>
          </div>
        </div>
      );
    }

    return (
      <TileView {...this.props}
          onAddDocumentItem={this.onAddDocumentItem} rowClassName={`col-12 ${styles.lossPotTileView}`}
        >
        <div>
          {selectElement}
          {this.props.children}
        </div>
      </TileView>
    );
  }
}
